import React from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { CategoryNav } from './CategoryNav';
import { LazyCategoryMegaNav } from './CategoryMegaNav.lazy';

/**
 * Renders the expanded mega-menu nav behind `printExpandedGalleryNav`; the flat
 * 8-category bar otherwise. Override locally with `?feature.printexpandedgallerynav=on`.
 * The mega nav is lazy-loaded so the default bucket never downloads it; the flat bar
 * stays synchronous because it is the default and the mega nav's own mobile fallback.
 */
export const CategoryNavSwitch = () => {
  const [isExpandedNavEnabled] = useIsFeatureEnabled('printExpandedGalleryNav');
  return isExpandedNavEnabled ? <LazyCategoryMegaNav /> : <CategoryNav />;
};
